<template>
    <nuxt-layout name="main" :dark="true" :favorite="true">
        <module-from ref="form" />
        <div :class="css.container" class="container">
            <!-- * 头部 -->
            <div :class="css.header" class="color-1 font-bold">
                <h1 :class="css.name" class="font-variable">{{ $t("MTH") }}</h1>
                <h2 :class="css.descript" class="font-variable">{{ $t("MTHDesc") }}</h2>
            </div>

            <!-- * 内容 -->
            <div :class="css.body">
                <!-- * 单选按钮组 -->
                <div :class="css.radios" class="color-1 font-bold">
                    <ui-radio v-model="mode" value="">RNA-seq</ui-radio>
                </div>

                <!-- * 上传控件 -->
                <div :class="css.input" @click="input?.click()">
                    <input :class="css.main" :accept="accept" type="file" ref="input" @change="methods.upload" />
                    <div :class="css.name">{{ $t("ChooseFile") }}</div>
                    <div :class="[css.descript, name && css.active]">{{ name || $t("MTHUploadDesc") }}</div>
                </div>

                <!-- * 下载控件 -->
                <div :class="css.download">
                    <ProjectRoute :class="css.link" to="https://rdgta.cdn.cyagen.com/rddc/data/mouse_RNA-seq.xlsx">
                        <ui-icon :class="css.icon" name="download" />
                        <div :class="css.name">{{ $t("ExampleFile") }}</div>
                    </ProjectRoute>
                </div>
            </div>

            <div :class="css.controls">
                <ui-button size="middle" :width="128" @click="methods.submit">{{ $t("Upload") }}</ui-button>
            </div>

            <div :class="css.introduce">
                {{ $t("MTHIntroduction") }}
            </div>
        </div>
    </nuxt-layout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiButton, UiRadio, UiIcon } from "various-ui";
//* 私有组件
import ModuleFrom from "./components/module-form/index.vue";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";

//* 组合函数
const { refs, nodes, methods } = useComposable();
const { name, mode, accept } = refs;
const { input, form } = nodes;
</script>
